/*
Ex: https://medium.com/@bolajifemi28/how-to-add-paypal-checkout-to-your-react-app-37d44c58a896

npm install — save react-async-script-loader

*/

import React from "react";
import ReactDOM from "react-dom";
import scriptLoader from "react-async-script-loader";
import { Spinner } from "reactstrap";
import RegisterAttendee from "../../RegisterAttendee";
import { Link } from "react-router-dom";

//var CLIENT_ID = "AbAQuikNYjLoVbUhMxDzWo-bqwYtqEOUNzEJLhZzffZrmEzZITEj4TMxCMjjTzgp2xFEPe3X4cdE32Zn&currency=USD";    //TEST
// var CLIENT_ID = "AaEIn2SRoI6qR5LnCgQSoDpUXGPWckGqEUjvGdoiMs_Ex0l9NMyMT5Q2eYtdfP4a6E4QW6BE8QrHMaH5&currency=USD";  //LIVE - old customer
var CLIENT_ID = "AVp4dnkgR61TVRWp6UOJSsvNG34fnPZKX2FMPs8sx2JAJTZlAStXWQB8mI1Z1BTOf3b2ETMLTN02EKPs&currency=USD";  //LIVE - new customer

//create button here
let PayPalButton = null;

class PaypalTravcon23Exhibitor extends React.Component {
    constructor(props) {
        super(props);

        var loginbuttonstyle = {};
        if (global.$registrationform.styles.login != null) {
            loginbuttonstyle = global.$registrationform.styles.login;
        }
        var paypaltrasactionfee = "0";
        if (global.$registrationform.payment.paypal != null && global.$registrationform.payment.paypal.transactionfee != null) {
            paypaltrasactionfee = global.$registrationform.payment.paypal.transactionfee;
        }

       //console.log(global.$regamount);
        // if (global.$code == "travcon2022exhibitor" && global.$selectedpaymenttype == "deposit") {
        //     if (global.$loginstatus == null || global.$loginstatus == "false") {
        //         global.$regamount = Number(global.$registrationform.payment.deposit.amount);
        //     }
        // }

        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            loginbuttonstyle: loginbuttonstyle,
            showButtons: false,
            loading: true,
            paypaltrasactionfee: paypaltrasactionfee,
            totalregamount: parseFloat(global.$regamount).toFixed(2),
            totalamount: Number(global.$regamount) + (Number(global.$regamount) * Number(paypaltrasactionfee) / Number(100)),
            paid: false,     // LIVE
            //paid: true     // TEST
        };
        this.hideRegisterButtonFromPaypal = this.hideRegisterButtonFromPaypal.bind(this);
        window.React = React; //needed for the PayPal React Component which comes with the library
        window.ReactDOM = ReactDOM; // needed for the PayPal React Component which comes with the library

        this.state.totalamount = parseFloat(this.state.totalamount).toFixed(2);
        global.$transactionfee = (Number(global.$regamount) * Number(this.state.paypaltrasactionfee) / Number(100))
        global.$regamount = Number(global.$regamount) + (Number(global.$regamount) * Number(this.state.paypaltrasactionfee) / Number(100));
        global.$regamount = parseFloat(global.$regamount).toFixed(2)
        if (global.$registrationform.payment.paypal.testmode != null && global.$registrationform.payment.paypal.testmode == true) {
            this.state.paid = true;
        }
        //console.log(this.state);
    }

    componentDidMount() {
        const { isScriptLoaded, isScriptLoadSucceed } = this.props;
        //console.log(isScriptLoaded, isScriptLoadSucceed);
        if (isScriptLoaded && isScriptLoadSucceed) {
            PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });
            this.setState({ loading: false, showButtons: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { isScriptLoaded, isScriptLoadSucceed } = nextProps;

        //console.log(isScriptLoaded, isScriptLoadSucceed);
        const scriptJustLoaded =
            !this.state.showButtons && !this.props.isScriptLoaded && isScriptLoaded;
        //console.log(!this.state.showButtons, !this.props.isScriptLoaded, isScriptLoaded)
        //console.log(scriptJustLoaded);

        if (scriptJustLoaded) {
            //console.log("scriptJustLoaded")
            if (isScriptLoadSucceed) {
                //console.log("ScriptLoadSucceed")
                PayPalButton = window.paypal.Buttons.driver("react", {
                    React,
                    ReactDOM
                });
                this.setState({ loading: false, showButtons: true });
            }
        }
    }
    createOrder = (data, actions) => {
        //console.log("creating order....")
        //console.log(global.$regamount, global.$attendeeregitems)
        //console.log("reg amount: "+global.$regamount)
        //console.log("transaction fee: "+Number(global.$regamount)*Number(this.state.paypaltrasactionfee)/Number(100));

        // if (global.$code == "travcon2022exhibitor" && global.$selectedpaymenttype == "deposit") {
        //     global.$regamount = Number(global.$registrationform.payment.deposit.amount);
        // }
        //console.log(global.$regamount);
        //var totalamount = Number(global.$regamount) + (Number(global.$regamount) * Number(this.state.paypaltrasactionfee) / Number(100)); // LIVE
        //console.log("totalamount: " + totalamount);
        //var totalamount = Number(0.05) + (Number(0.05)*Number(this.state.paypaltrasactionfee)/Number(100));  // TEST 
        var finalamount = parseFloat(global.$regamount).toFixed(2);
        //console.log("paypal final amount: " + finalamount)
        var desc = global.$attendeeregitems.toString();
        //console.log(desc);
        //console.log(desc.substring(0, 120));
        //console.log(desc.length);
        // Maximum Length for desc should be 127;

        var inputs = {
            intent: "CAPTURE",
            purchase_units: [
                {
                    description: `${desc.substring(0, 120)}`,
                    amount: {
                        currency_code: "USD",
                        value: Number(finalamount)
                    }
                }
            ]
        }
        //console.log(inputs);
        return actions.order.create(inputs);
    };

    onApprove = (data, actions) => {
        actions.order.capture().then(details => {
            const paymentData = {
                payerID: data.payerID,
                orderID: data.orderID
            };
            //console.log("Payment Approved: ", paymentData);
            this.setState({ showButtons: false, paid: true });
        });
    };

    render() {
        const { showButtons, loading, paid } = this.state;
        //console.log("paypal render")
        return (
            <div className="main">
                {loading && <Spinner />}

                {showButtons && (
                    <div className="payment-div">
                        <div className="payment-summary-div">
                            {
                                /*
                                global.$attendeeregitems != null ?
                                    (
                                        <p>{this.displayRegItems()}</p>
                                    )
                                    :
                                    ('')
                                */
                            }
                            <br />

                            <p className="payment-amount">Total registration amount = ${this.state.totalregamount}</p>
                            <p className="payment-amount">Transaction fee = ${(parseFloat(Number(this.state.totalregamount) * Number(this.state.paypaltrasactionfee) / Number(100)).toFixed(2))}</p>
                            <p className="payment-amount">Total Amount = ${this.state.totalamount}</p>
                        </div>

                        <PayPalButton
                            createOrder={(data, actions) => this.createOrder(data, actions)}
                            onApprove={(data, actions) => this.onApprove(data, actions)}
                        />
                    </div>
                )}

                {paid && (
                    <div className="main">
                        { /*<p className="payment-success">Successfully paid.</p>*/}
                        <RegisterAttendee regattendeestatus={this.props.regattendeestatus} reggueststatus={this.props.reggueststatus} type={this.props.type} hideRegisterButtonFromPaypal={this.hideRegisterButtonFromPaypal} />
                        {/* {
                            global.$loginstatus.includes("true") ?
                                (
                                    ''
                                )
                                :
                                (
                                    
                                    global.$deferredpromo == "Y"?
                                    ('')
                                    :
                                    (
                                        <p className="payment-login" style={this.state.loginbuttonstyle}><Link to={`/LoginForm`}>Click here to login</Link></p>
                                    )
                                )
                        } */}
                    </div>
                )}
            </div>
        );
    }

    hideRegisterButtonFromPaypal() {

        //console.log("hideRegisterButtonFromPaypal()");
        this.props.hideRegisterButtonFromPaypalHome()
    }
    displayRegItems() {
        //console.log(global.$attendeeregitems);
        //console.log(global.$guestregitems);
        //console.log(global.$regdiscountinfo);
        var discount = '';
        if (global.$regdiscountinfo != null && global.$regdiscountinfo != "" && global.$regdiscountinfo.discountprice != null) {
            //console.log(global.$regdiscountinfo.discountprice);
            discount = "Discount - " + global.$regdiscountinfo.discountprice;
        }
        var totalregitem = '';
        if (global.$guestregitems != null && global.$regguestinfo != "") {
            if (global.$regdiscountinfo != null && global.$regdiscountinfo != "") {
                totalregitem = global.$attendeeregitems.toString() + ',' + global.$guestregitems.toString() + ",Discount - " + global.$regdiscountinfo.discountprice;
            }
            else {
                totalregitem = global.$attendeeregitems.toString() + ',' + global.$guestregitems.toString();
            }
        }
        else {
            totalregitem = global.$attendeeregitems.toString();
        }

        totalregitem = totalregitem.split(",");

        return totalregitem.map(item => {
            return (
                <div className="payment-items">
                    {item}
                </div>
            )
        })
    }

}
export default scriptLoader(`https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&disable-funding=credit,paylater`)(PaypalTravcon23Exhibitor);